<template>
  <!--<v-fab-transition>--> <!-- funktioniert nicht bhu -->
  <v-fade-transition><!-- geomer BHU -->
  <v-card
    :class="cardClasses"
    :style="cardStyles"
    v-bind="cardAttr"
    v-if="show"
    v-draggable-win="cardDraggable"
  >
    <v-img :src="backgroundImage">
      <v-toolbar v-bind="toolbarAttr" v-if="showHeaderToolbar"><!-- geomer BHU -->
        <v-icon color="onprimary" class="mr-4">{{ icon }}</v-icon>
        <v-toolbar-title class="wgu-win-title" v-if="moduleLabel">{{
          $t(moduleLabel)
        }}</v-toolbar-title>
        <v-toolbar-title class="wgu-win-title" v-else>{{
          $t(moduleName + '.title')
        }}</v-toolbar-title><!-- geomer BHU: allow specific Label with prop moduleLabel -->

        <v-spacer></v-spacer>
        <slot name="wgu-win-toolbar"></slot>

        <v-spacer style="flex-grow: 10 !important;"></v-spacer><!-- geomer BHU -->

        <slot name="wgu-win-toolbar-additionalIcon"></slot><!-- geomer BHU -->
        <v-spacer style="flex-grow: 2 !important;"></v-spacer>

        <v-btn
          color="onprimary"
          v-if="minimizable"
          icon
          small
          @click="minimized = !minimized"
        >
          <v-icon v-if="minimized">keyboard_arrow_down</v-icon><!-- geomer BHU changed icon -->
          <v-icon v-else>keyboard_arrow_up</v-icon><!-- geomer BHU changed icon -->
        </v-btn>
        <v-btn color="onprimary" v-if="closable" icon small class="mr-0"
          @click="toggleUi">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
    </v-img>

    <!-- Default slot for module content -->
    <div v-show="!minimized">
      <slot name="default"></slot>
    </div>
  </v-card>
</v-fade-transition><!-- geomer BHU -->
<!--</v-fab-transition>-->
</template>

<script>
import { DraggableWin } from '../../directives/DraggableWin';
import { WguEventBus } from '../../WguEventBus';
export default {
  name: 'wgu-module-card',
  inheritAttrs: false,
  directives: {
    DraggableWin
  },
  props: {
    // Common properties
    moduleName: { type: String, required: true },
    icon: { type: String, required: true },
    win: { type: String, required: false, default: 'floating' },
    minimizable: { type: Boolean, required: false, default: false },
    closable: { type: Boolean, required: false, default: true },
    backgroundImage: { type: String, required: false, default: undefined },
    visible: { type: Boolean, required: false, default: false },
    // Positioning / sizing properties will be ignored for sidebar cards.
    draggable: { type: Boolean, required: false, default: true },
    initPos: { type: Object, required: false },
    height: { type: [Number, String], required: false, default: undefined },
    width: { type: [Number, String], required: false, default: undefined },
    maxHeight: { type: [Number, String], required: false, default: undefined },
    maxWidth: { type: [Number, String], required: false, default: undefined },
    minHeight: { type: [Number, String], required: false, default: undefined },
    minWidth: { type: [Number, String], required: false, default: undefined },
    moduleLabel: { type: String, required: false, default: undefined }, /* geomer BHU changed icon */
    showHeaderToolbar: { type: Boolean, required: false, default: true } /* geomer BHU changed icon */
  },
  data () {
    return {
      show: this.visible,
      minimized: false
    };
  },
  created () {
    WguEventBus.$on(this.moduleName + '-visibility-change', (visible) => {
      this.show = visible;
      this.$emit('visibility-change', visible);
    });
    /* geomer BHU */
    WguEventBus.$on(this.moduleName + '-visibility-toggle', (visible) => {
      this.show = !this.show;
      this.$emit('visibility-change', this.show);
    });
  },
  updated () {
    if (this.show && this.win === 'sidebar') {
      WguEventBus.$emit('sidebar-scroll', this);
    }
  },
  computed: {
    cardClasses () {
      return this.win === 'floating'
        ? ['wgu-module-card', 'wgu-floating']
        : ['wgu-module-card', 'wgu-sidebar'];
    },
    cardStyles () {
      return this.win === 'floating'
        ? {
            left: this.initPos ? this.initPos.left + 'px' : '0px',
            top: this.initPos ? this.initPos.top + 'px' : '0px'
          }
        : {};
    },
    cardAttr () {
      return this.win === 'floating'
        ? {
            height: this.height,
            width: this.width,
            maxHeight: this.maxHeight,
            maxWidth: this.maxWidth,
            minHeight: this.minHeight,
            minWidth: this.minWidth
          }
        : {};
    },
    cardDraggable () {
      return this.win === 'floating' ? this.draggable : false;
    },
    toolbarAttr () {
      return this.backgroundImage
        ? {
            dark: true,
            flat: true,
            color: 'transparent'
          }
        : {
            color: 'primary',
            class: 'onprimary--text'
          };
    }
  },
  methods: {
    toggleUi () {
      WguEventBus.$emit(this.moduleName + '-visibility-change', !this.show);
    }
  }
};
</script>
